import _regeneratorRuntime from "/home/runner/work/ami/ami/jaenjs/templates/jaen-template-shopify/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { KeyManager } from '@snek-at/snek-api-client';
import { stringify } from '../utils.js';
export var makeFn = function makeFn(_ref) {
  var url = _ref.url;
  return function (snekFunction, options) {
    var fn = function fn(args) {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$fn$execute, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fn.execute(args);

              case 2:
                _yield$fn$execute = _context.sent;
                data = _yield$fn$execute.data;
                return _context.abrupt("return", data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    };

    fn.options = options;

    fn.execute = function (args) {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var snekApiHeaders, res, _yield$res$json, data, errors;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                snekApiHeaders = KeyManager.getHeaders();
                console.log('snekApiHeaders', snekApiHeaders);
                _context2.prev = 2;
                _context2.next = 5;
                return fetch(url, {
                  method: 'POST',
                  headers: Object.assign({
                    'Content-Type': 'application/json'
                  }, snekApiHeaders),
                  body: JSON.stringify({
                    query: "\n              mutation {\n                ".concat(options.name, "(fnArgs: ").concat(stringify(args), ")\n              }\n            ")
                  })
                });

              case 5:
                res = _context2.sent;
                _context2.next = 8;
                return res.json();

              case 8:
                _yield$res$json = _context2.sent;
                data = _yield$res$json.data;
                errors = _yield$res$json.errors;
                return _context2.abrupt("return", {
                  data: JSON.parse(data[options.name]),
                  errors: errors || []
                });

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](2);
                console.error(_context2.t0);
                return _context2.abrupt("return", {
                  data: null,
                  errors: [_context2.t0]
                });

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 14]]);
      }));
    };

    fn.server = snekFunction;
    return fn;
  };
};
export var browserMakeFn = function browserMakeFn(args) {
  return function (snekFunction, options) {
    var fn = makeFn(args)(snekFunction, options);

    fn.server = function () {
      throw new Error('Executing a server function in the browser is not supported.');
    };

    return fn;
  };
};